export default __webpack_public_path__ + "static/media/gold_passcode.cfbcd1b2.jpg";